import {Header, Surface} from "tmwx-design-web/src";
import {useSelector} from "react-redux";
import {RootState} from "gui-common/redux/store";
import {Script} from "gui-common/redux/data/pythonScript";
import Text from "tmwx-design-web/src/components/Text"

const ScriptDetails = () => {
    const scriptD = useSelector<RootState, Script>(state => state.pythonScript.script)

    return (
        <Surface style={{marginBottom: 4, marginLeft: 4, marginRight: 4, width: '100%'}}>
            <Header title={scriptD.ptcPyCodeName + ' - ' + scriptD.ptcPyCodeVersion}/>

            <Text style={{whiteSpace: 'pre-wrap', fontFamily: 'monospace'}}>
                {scriptD.ptcPyCode}
            </Text>
        </Surface>
    )
}

export default ScriptDetails;